import * as React from "react"

const SearchIcon = (props) => (
  <svg
    {...props}
    width={props.width}
    height={props.height}
    className="ga_search_mobile"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{"Search"}</title>
    <g
      transform="translate(1 1)"
      stroke={props.stroke}
      fill={props.fill}
      fillRule="evenodd"
    >
      <circle cx={7} cy={7} r={7} />
      <path strokeLinecap="round" d="m12 12 5.654 5.654" />
    </g>
  </svg>
)

export default SearchIcon
